import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { HttpService } from 'src/app/http.service';
import { SnackbarService } from 'src/app/snackbar.service';
import { TimeService } from 'src/app/time.service';

@Component({
  selector: 'app-view-ltl-orders',
  templateUrl: './view-ltl-orders.component.html',
  styleUrls: ['./view-ltl-orders.component.scss']
})
export class ViewLtlOrdersComponent implements OnInit {

  displayedColumns = ['status', 'date', 'comments']
  orderDetails: any = [];
  orderData: any;
  documentsArray = [];
  tabIndex = 0;
  selectedOption;
  showLoader = false;
  order_details;
  awb_status;
  trails_array :any =[];
  time_line:any = {}
  trails: any = [];

  service_provider
  active_status: string;
  columndata: any;
  pickup: any;
  delivery: any;
  awb_number: any;
  client: any;
  created_date: any;
  deliveryEdd: any;
  constructor(private dialogRef: MatDialogRef<ViewLtlOrdersComponent>, @Inject(MAT_DIALOG_DATA) private parentData: any,
    public timeService: TimeService, private http: HttpService, private snackBar: SnackbarService, private translate: TranslateService) { }

  ngOnInit() {
    this.orderData = this.parentData;
    this.service_provider = this.parentData.service_providers ? this.parentData.service_providers : '';
    this.order_details = this.orderData.ref_numbers ? this.orderData.ref_numbers : '';
    this.getTrails();
  }

  getIndianDate(date) {
    const initial = date.split(/\//);
    return [ initial[1], initial[0], initial[2] ].join('/'); //=> 'dd/mm/yyyy'
  }

  getTrails() {
    let payload = {
      order: this.orderData._id
    }
   
    this.http.post('orderLTL/trails', payload).subscribe(
      (response: any) => {
        if (response && response.statusCode == 200) {
          
          this.trails = response.data.event;
          this.awb_number= response.data.awb;
          this.client = response.data.client;
          this.created_date = response.data.created_at;
          let trailsData =response.data.order;
          this.columndata = trailsData;
          this.pickup =response.data.order.pickup_locations;
          this.delivery =response.data.order.delivery_locations;
          this.deliveryEdd= response.data.order.edd ? this.timeService.toShortDate(response.data.order.edd):'N/A';
          this.awb_status= response.data.status;
          this.trails_array = [];
          this.time_line = response.data.timeline;
          this.trails.reverse().forEach((element, ind) => {
            const temp: any = {};            
            temp.status = element.status ? element.status : 'N/A';
            temp.comments = element.comment ? element.comment : 'N/A';
            temp.date= element.date_time;
            this.trails_array.push(temp);
          })
        }
      })
  }

  toShortDateTime(value) {
    return (value) ? this.timeService.toShortDateTime(value) : 'N/A';
  }
  toShortDate(value) {
    return (value) ? this.timeService.toShortDate(value) : 'N/A';
  }
  closeModal() {
    this.dialogRef.close();
  }
  selectOption(option) {
    this.selectedOption = option
  }

  switchTab(tab: number) {
    this.tabIndex = tab;
  }

  addNewAWBDetail() {
    let newOrderdetail = {
      option_selected: {},
      value: ''
    };

    this.order_details.push(newOrderdetail)
  }

  removeOrderDetail(index) {
    this.order_details.splice(index, 1);
    this.order_details = [...this.order_details];
  }

  addAWBDetails() {
    const payload = {
      order: this.orderData._id,
      ref_number: this.order_details.map((num) => {
        return num.value
      })
    }
    let url = 'orderLTL/ref_number';
    this.showLoader = true;
    this.http.post(url, payload).subscribe((response: any) => {
      this.showLoader = false;
      if (response && response.statusCode == 200) {
        this.snackBar.openSnackBar('Order details updated sucessfully');
        this.dialogRef.close(response);
      }
    },
      (err) => {
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      })
  }
}
